import React, { useState } from "react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Box, Grid, Typography } from "@mui/material";
import BarEcharts from "./BarEcharts";
import { Input, Space, DatePicker, Select, Card, Popover, Button } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useDispatch, useSelector } from "react-redux";
import { fetchTab2Request } from "../../store/actions/insight";
import ATSPopover from "../../components/ATSPopover";
// import { CalendarOutlined } from '@ant-design/icons';
dayjs.extend(customParseFormat);
const { Option } = Select;
const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";
const today = new Date();
const lastWeek = new Date(today);
lastWeek.setDate(today.getDate() - 7);
const currentStartDate = `${lastWeek.getFullYear()}-${(lastWeek.getMonth() + 1)
  .toString()
  .padStart(2, "0")}-${lastWeek.getDate().toString().padStart(2, "0")}`;
const currentEndDate = `${today.getFullYear()}-${(today.getMonth() + 1)
  .toString()
  .padStart(2, "0")}-${today.getDate().toString().padStart(2, "0")}`;

const InsightsNewGraph = () => {
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(currentStartDate);
  const [endDate, setEndDate] = useState(currentEndDate);
  const locations = useSelector((state) => state.insight.locations);
  const filters = useSelector((state) => state.insight.tab2.filters);
  const isLoading = useSelector((state) => state.insight.tab2.isLoading);
  const insightData = useSelector((state) => state.insight.tab2.data);

  const onChangeStartDate = (_, dateStr) => {
    console.log("onChange:", dateStr);
    const rangePickerStart = new Date(dateStr);
    const startDate = `${rangePickerStart.getFullYear()}-${(
      rangePickerStart.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${rangePickerStart
      .getDate()
      .toString()
      .padStart(2, "0")}`;
    setStartDate(startDate);
  };
  const onChangeEndDate = (_, dateStr) => {
    console.log("onChange:", dateStr);
    const rangePickerEnd = new Date(dateStr);
    const endDate = `${rangePickerEnd.getFullYear()}-${(
      rangePickerEnd.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${rangePickerEnd
      .getDate()
      .toString()
      .padStart(2, "0")}`;
    setEndDate(endDate);
    console.log(endDate);
  };
  const handleLastUpdatedFilterChange = (e) => {
    // const rangePickerStart = new Date(e[0]);
    // const rangePickerEnd = new Date(e[1]);
    // const startDate = `${rangePickerStart.getFullYear()}-${(
    //   rangePickerStart.getMonth() + 1
    // )
    //   .toString()
    //   .padStart(2, "0")}-${rangePickerStart
    //     .getDate()
    //     .toString()
    //     .padStart(2, "0")}`;
    // const endDate = `${rangePickerEnd.getFullYear()}-${(
    //   rangePickerEnd.getMonth() + 1
    // )
    //   .toString()
    //   .padStart(2, "0")}-${rangePickerEnd
    //     .getDate()
    //     .toString()
    //     .padStart(2, "0")}`;

    dispatch(
      fetchTab2Request({
        locations,
        filters: { ...filters, startDate, endDate },
      })
    );
  };

  const handleAssetFilterChange = (val) => {
    dispatch(
      fetchTab2Request({ locations, filters: { ...filters, assettype: val } })
    );
  };

  return (
    <div style={{ margin: "0 auto", display: "flex", flexDirection: "column" }}>
      <div style={{ textAlign: "right", width: "100%", marginTop: 5 }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          style={{
            backgroundColor: "white", // White background for the grid container
            padding: "20px", // Padding for spacing inside the card
            borderRadius: "8px", // Rounded corners
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)", // Shadow effect to mimic card
          }}
        >
          {/* Asset Type Label and Dropdown */}
          <Grid item xs={3.25}>
            <Typography
              variant="body2"
              style={{
                marginBottom: "8px",
                textAlign: "left", // Align label to the left
              }}
            >
              Asset Type
            </Typography>
            <Select
              defaultValue={filters.assettype}
              onChange={handleAssetFilterChange}
              style={{
                width: "100%",
                height: "44px", // Increased height
                textAlign: "left",
                border: "1px solid black", // Black border for Select
                borderRadius: "4px", // Rounded corners for the dropdown
              }}
            >
              <Option value="allassets"> All</Option>
              <Option value="BIN">BIN</Option>
              <Option value="CAN">CAN</Option>
              <Option value="HOSE">HOSE</Option>
              <Option value="POD">POD</Option>
              <Option value="UNKNOWN">UNKNOWN</Option>
            </Select>
          </Grid>

          {/* From Date Label and Start Date Picker */}
          <Grid item xs={3.25}>
            <Typography
              variant="body2"
              style={{
                marginBottom: "8px",
                textAlign: "left", // Align label to the left
              }}
            >
              From
            </Typography>
            <DatePicker
              defaultValue={dayjs(currentStartDate, dateFormat)}
              onChange={onChangeStartDate}
              format={"MM-DD-YYYY"}
              style={{
                width: "100%",
                height: "44px", // Increased height for DatePicker
                border: "1px solid black", // Black border for DatePicker
                borderRadius: "4px", // Optional rounded corners
              }}
            />
          </Grid>

          {/* To Date Label and End Date Picker */}
          <Grid item xs={3.25}>
            <Typography
              variant="body2"
              style={{
                marginBottom: "8px",
                textAlign: "left", // Align label to the left
              }}
            >
              To
            </Typography>
            <DatePicker
              format={"MM-DD-YYYY"}
              onChange={onChangeEndDate}
              defaultValue={dayjs(currentEndDate, dateFormat)}
              style={{
                width: "100%",
                height: "44px", // Increased height for DatePicker
                border: "1px solid black", // Black border for DatePicker
                borderRadius: "4px", // Optional rounded corners
              }}
            />
          </Grid>

          {/* Apply Button */}
          <Grid item xs={2}>
            <Button
              type="default"
              shape="round"
              onClick={handleLastUpdatedFilterChange}
              style={{
                backgroundColor: "white",
                border: "1px solid black", // Black border for the button
                width: "100%",
                marginTop: "25px",
                height: "44px", // Increased height for the button
                fontSize: "14px", // Optional font size adjustment
              }}
            >
              <h6 className="font-face-vzw-header">Apply</h6>
            </Button>
          </Grid>
        </Grid>
      </div>
      {!isLoading &&
        insightData.length > 0 &&
        insightData.map((insight) => (
          <React.Fragment key={insight.key}>
            <div
              style={{
                marginTop: 50,
                textAlign: "left",
                width: "100%",
                marginLeft: 18,
              }}
            >
              <h5 style={{ fontSize: "24px", fontWeight: "bold" }}>
                {insight.locationName}
              </h5>
              <hr
                style={{
                  borderTop: "1px solid #000", // Divider color and thickness
                  marginTop: "10px", // Top margin (space before the line)
                  marginBottom: "40px", // Bottom margin (space after the line)
                  width: "100%",
                  marginLeft: -18,
                }}
              />
            </div>
            <div style={{ marginTop: 15 }}></div>
            <Grid2
              container
              xs={12}
              spacing={12}
              sm={12}
              md={12}
              direction="row"
              ml={0.1}
            >
              <Grid2 item>
                <Box>
                  <div style={{ fontSize: 14 }}>
                    <span
                      style={{
                        paddingLeft: 6,
                        paddingRight: 20,
                        fontSize: "14px",
                      }}
                    >
                      Avg Total Days
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "24px",
                      marginLeft: "10px",
                      textAlign: "left",
                      fontWeight: "bold",
                    }}
                  >
                    {/* Left side vertical line */}
                    <div
                      style={{
                        height: "30px",
                        width: "5px",
                        backgroundColor: "#FED60E",
                        marginRight: "10px", // Adjust spacing between the line and text
                      }}
                    ></div>

                    {/* 7.24 value */}
                    <div>{insight.avgTotalDays.value}</div>

                    {/* Right side percentage */}
                    <div
                      style={{
                        fontSize: "18px",
                        marginLeft: "20px", // Adjust spacing between 7.24 and the percentage
                        color: "green",
                      }}
                    >
                      <div className="reporting-gateway-count">
                        <span className="down">
                          {insight.avgTotalDays.percentage ?? 0}%
                        </span>
                      </div>
                    </div>
                  </div>
                </Box>
              </Grid2>
              <Grid2 item>
                <Box>
                  <div style={{ fontSize: 14 }}>
                    <span
                      style={{
                        paddingLeft: 6,
                        paddingRight: 20,
                        fontSize: "14px",
                      }}
                    >
                      Avg Days at DC
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "24px",
                      marginLeft: "10px",
                      fontWeight: "bold",
                      textAlign: "left",
                    }}
                  >
                    {/* Left side vertical line */}
                    <div
                      style={{
                        height: "30px",
                        width: "5px",
                        backgroundColor: "#006FC1",
                        marginRight: "10px", // Adjust spacing between the line and text
                      }}
                    ></div>

                    {/* 7.24 value */}
                    <div>{insight.avgDayAtDC.value}</div>

                    {/* Right side percentage */}
                    <div
                      style={{
                        fontSize: "18px",
                        marginLeft: "20px", // Adjust spacing between 7.24 and the percentage
                        color: "green",
                      }}
                    >
                      <div className="reporting-gateway-count">
                        <span className="down">
                          {insight.avgDayAtDC.percentage ?? 0}%
                        </span>
                      </div>
                    </div>
                  </div>
                </Box>
              </Grid2>

              <Grid2 item>
                <Box>
                  <div style={{ fontSize: 14 }}>
                    <span
                      style={{
                        paddingLeft: 6,
                        paddingRight: 20,
                        fontSize: "14px",
                      }}
                    >
                      Avg Days at Yard
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "24px",
                      marginLeft: "10px",
                      textAlign: "left",
                    }}
                  >
                    {/* Left side vertical line */}
                    <div
                      style={{
                        height: "30px",
                        width: "5px",
                        backgroundColor: "#63D48E",
                        marginRight: "10px", // Adjust spacing between the line and text
                      }}
                    ></div>

                    {/* 7.24 value */}
                    <div>{insight.avgDayAtYard.value}</div>

                    {/* Right side percentage */}
                    <div
                      style={{
                        fontSize: "18px",
                        marginLeft: "20px", // Adjust spacing between 7.24 and the percentage
                        color: "green",
                      }}
                    >
                      <div className="reporting-gateway-count">
                        <span className="down">
                          {insight.avgDayAtYard.percentage ?? 0}%
                        </span>
                      </div>
                    </div>
                  </div>
                </Box>
              </Grid2>
              <Grid2 item>
                <Box>
                  <div style={{ fontSize: 14 }}>
                    <span
                      style={{
                        paddingLeft: 6,
                        paddingRight: 20,
                        fontSize: "14px",
                      }}
                    >
                      Avg Days in Transit
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "24px",
                      marginLeft: "10px",
                      fontWeight: "bold",
                      textAlign: "left",
                    }}
                  >
                    {/* Left side vertical line */}
                    <div
                      style={{
                        height: "30px",
                        width: "5px",
                        backgroundColor: "#FF8027",
                        marginRight: "10px", // Adjust spacing between the line and text
                      }}
                    ></div>

                    {/* 7.24 value */}
                    <div>{insight.avgDayInTransit.value}</div>

                    {/* Right side percentage */}
                    <div
                      style={{
                        fontSize: "18px",
                        marginLeft: "20px", // Adjust spacing between 7.24 and the percentage
                        color: "green",
                      }}
                    >
                      <div className="reporting-gateway-count">
                        <span className="down">
                          {insight.avgDayInTransit.percentage ?? 0}%
                        </span>
                      </div>
                    </div>
                  </div>
                </Box>
              </Grid2>
              <Grid2 item>
                <Box>
                  <div style={{ fontSize: 14 }}>
                    <span
                      style={{
                        paddingLeft: 6,
                        paddingRight: 20,
                        fontSize: "14px",
                      }}
                    >
                      Avg Cycle Count
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "24px",
                      marginLeft: "10px",
                      fontWeight: "bold",
                      textAlign: "left",
                    }}
                  >
                    {/* Left side vertical line */}
                    <div
                      style={{
                        height: "30px",
                        width: "5px",
                        backgroundColor: "#E084F9",
                        marginRight: "10px", // Adjust spacing between the line and text
                      }}
                    ></div>

                    {/* 7.24 value */}
                    <div>{insight.avgDayCycleCount.value}</div>

                    {/* Right side percentage */}
                    <div
                      style={{
                        fontSize: "18px",
                        marginLeft: "20px", // Adjust spacing between 7.24 and the percentage
                        color: "green",
                      }}
                    >
                      <div className="reporting-gateway-count">
                        <span className="down">
                          {insight.avgDayCycleCount.percentage ?? 0}%
                        </span>
                      </div>
                    </div>
                  </div>
                </Box>
              </Grid2>
            </Grid2>

            <Card
              style={{
                marginTop: "20px",
                borderRadius: "12px",
              }}
            >
              <BarEcharts data={insight.data} />
            </Card>
            <hr
              style={{
                borderTop: "2px solid #000000 !important",
                opacity: "unset !important,",
                width: "100%",
              }}
            />
          </React.Fragment>
        ))}
    </div>
  );
};

export default InsightsNewGraph;
